<div class="formgrid grid">
  <div class="field col my-0 py-0">
    <label *ngIf="title">
      {{ title }}
    </label>
    <p-autoComplete
      [multiple]="true"
      [(ngModel)]="selectedProduct"
      [suggestions]="productSearchResults"
      (completeMethod)="onSearchQueryChanged($event)"
      [placeholder]="productSearchPlaceholder"
      (onSelect)="onProductSelected($event)"
      (onKeyUp)="onSearch($event)"
      [emptyMessage]="'No Products Found'"
      [showEmptyMessage]="true"
      field="name"
    >
      <ng-template let-product pTemplate="item">
        <div class="ui-helper-clearfix">
          <img
            *ngIf="product.images?.length; else productIcon"
            [src]="product.images | getFirstAvailableImageForSize: '60'"
            [alt]="product.name"
            style="width: 40px; display: inline-block; margin: 5px 0 2px 5px"
          />
          <ng-template #productIcon>
            <i
              *ngIf="product.id"
              class="material-icons-round mi-image"
              style="width: 40px; display: inline-block; margin: 5px 0 2px 5px"
            ></i>
            <i
              *ngIf="!product.id"
              class="material-icons-round mi-add"
              style="width: 40px; display: inline-block; margin: 5px 0 2px 5px"
            ></i>
          </ng-template>
          <div style="font-size: 18px; float: right; margin: 10px 10px 0 0">
            {{ product.name }}
          </div>
        </div>
      </ng-template>
    </p-autoComplete>
  </div>
</div>
